<template lang="pug">
    v-card
        //loading-dialog(:loading="loadingData")
        //crud-data-table.px-5.mt-5(
            v-if="!loadingData"
            :service="serviceTable" 
            :headers="headerTable" 
            :deleteButton="()=>{true}" 
            noAutoWidth 
            @show="submitShow($event)" 
            noSearchBox
            :filters="[]"
            )
        model-data-table(
            loading-text="Cargando documentos históricos..."
            no-data-text="Sin documentos históricos."
            no-search
            no-remove
            ref="table"
            v-bind="tableProps"
            @detail="submitShow"
            )
            template( slot='actions' slot-scope='props' )
                r-btn-action( 
                    color='dark'
                    tooltip='PDF'
                    @click='submitPdf(props)' 
                )
                    v-icon picture_as_pdf
        detail-dialog(ref="invoiceReceivableDialog" :invoiceId="invoiceId" readOnly)
</template>

<script>
//-
import { ModelDataTable, RBtnAction } from '@/components/reusable_components/next'
import SlSaleInvoiceMdl from '@/models/Sale/SlSaleInvoice.js'
import TableHeaders from '@/views/Customer/tables/customerReceivableInvoice/Headers.js'
import DetailDialog from '@/components/dialogs/invoice/InvoiceDetailDialog'
//-
export default {
    name: 'customer-historic-invoice',
    props: {},
    data: function() {
        return {
            headerTable: TableHeaders,
            filters: [
                {
                    name: 'number',
                    props: {
                        label: 'Folio',
                    },
                    flex: {
                        sm6: true,
                        lg5: true,
                    },
                    type: 'text-field',
                },
            ],
            customerId: null,
            invoiceId: null,
        }
    },
    computed: {
        tableProps() {
            return {
                service: SlSaleInvoiceMdl,
                paramFilter: {
                    sl_customer_id: this.customerId,
                },
                headers: this.headerTable,
                filters: this.filters,
            }
        },
    },
    methods: {
        /**
         */
        setCustomerId() {
            this.customerId = this.$route.params.id
        },

        /**
         * @description
         * Print sale invoice PDF
         *
         * @param      {object}  event   The event
         * @return     {object}  blob file
         */
        submitPdf(event) {
            return event.item.toPdf()
        },

        /**
         *
         */
        submitShow(event) {
            this.invoiceId = event.item.id
            this.$refs.invoiceReceivableDialog.open = true
        },
    },
    components: {
        RBtnAction,
        'model-data-table': ModelDataTable,
        'detail-dialog': DetailDialog,
    },
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    beforeMount: function() {
        this.setCustomerId()
    },
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss"></style>
